module.exports = {
  control: {
    allow_type: [], // 允许配置的控件类型
    data: []  // 配置的控件数据
  }
}



// WEBPACK FOOTER //
// ./src/components/Model/widgetAttr/params.js